import {
  GET_STATIC_PAGE_REQUEST,
  GET_STATIC_PAGE_SUCCESS,
  GET_STATIC_PAGE_FAILURE
} from 'Store/constants';

const initialState = {
  data: null,
  isLoading: false,
  hasLoaded: false,
  error: null,
  notFound: false,
  slug: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STATIC_PAGE_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasLoaded: state.slug === action.slug ? state.hasLoaded : false,
        error: null,
        notFound: state.slug === action.slug ? state.notFound : false,
        slug: action.slug
      };

    case GET_STATIC_PAGE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        hasLoaded: true,
        error: null,
        notFound: false,
        slug: action.slug
      };

    case GET_STATIC_PAGE_FAILURE:
      return {
        ...state,
        data: null,
        isLoading: false,
        hasLoaded: true,
        error: action.payload,
        notFound: Boolean(action.notFound || (action.payload && action.payload.notFound)),
        slug: action.slug
      };

    default:
      return state;
  }
};
